import React, { useEffect, useState } from 'react';
import { API_ENDPOINTS } from '../config/api';

const date = value => value ? new Date(value).toLocaleString('en-NG', { timeZone: 'Africa/Lagos' }) : '-';
export default function NotificationReaders({ id, type = 'announcement', onClose }) {
  const [reports, setReports] = useState([]);
  const [selected, setSelected] = useState(id || '');
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('all');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let stopped = false;
    const refresh = async () => {
      try {
        const query = new URLSearchParams({ type, ...(id ? { id } : {}) });
        const response = await fetch(`${API_ENDPOINTS.BASE_URL}/api/admin/notifications/receipts?${query}`, { credentials: 'include' });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || 'Unable to load confirmations');
        if (!stopped) { setReports(data); setSelected(value => value || data[0]?.id || ''); setError(''); }
      } catch (error) { if (!stopped) setError(error.message); }
      finally { if (!stopped) setLoading(false); }
    };
    refresh();
    const timer = setInterval(refresh, 15000);
    return () => { stopped = true; clearInterval(timer); };
  }, [id, type]);
  const report = reports.find(item => item.id === selected);
  const readers = (report?.readers || []).filter(reader =>
    `${reader.name} ${reader.email} ${reader.children.join(' ')}`.toLowerCase().includes(search.toLowerCase()) &&
    (status === 'all' || (status === 'unseen' && !reader.isRead) || (status === 'viewed' && reader.isRead) ||
      (status === 'acknowledged' && reader.acknowledgedAt) || (status === 'pending' && !reader.acknowledgedAt)));
  return <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-3" onClick={onClose}>
    <section role="dialog" aria-modal="true" aria-labelledby="receipt-title" className="bg-white rounded-lg w-full max-w-6xl max-h-[90vh] overflow-auto p-5 text-slate-900" onClick={event => event.stopPropagation()}>
      <header className="flex justify-between items-center gap-3 mb-4">
        <h2 id="receipt-title" className="text-xl font-bold">Parent Confirmations</h2>
        <button type="button" onClick={onClose} className="border rounded px-3 py-2">Close</button>
      </header>
      {loading && <p role="status">Loading confirmations...</p>}
      {error && <p role="alert" className="text-red-700 mb-4">{error}</p>}
      {!loading && !reports.length && !error && <p>No notifications found.</p>}
      {reports.length > 1 && <label className="block mb-4">Notification<select className="block border rounded p-2 w-full" value={selected} onChange={event => setSelected(event.target.value)}>
        {reports.map(item => <option key={item.id} value={item.id}>{item.title}</option>)}
      </select></label>}
      {report && <>
        <h3 className="font-semibold mb-3">{report.title}</h3>
        <p className="mb-4 text-sm">{report.totalParents} parents / {report.viewed} viewed / {report.totalParents - report.viewed} unseen{type === 'announcement' && ` / ${report.acknowledged} acknowledged`}</p>
        <div className="flex flex-wrap gap-3 mb-4">
          <input aria-label="Search parents" placeholder="Search parents" value={search} onChange={event => setSearch(event.target.value)} className="border rounded px-3 py-2 w-full sm:w-auto sm:flex-1 min-w-0" />
          <select aria-label="Confirmation status" value={status} onChange={event => setStatus(event.target.value)} className="border rounded px-3 py-2 w-full sm:w-auto">
            <option value="all">All parents</option><option value="viewed">Viewed</option><option value="unseen">Unseen</option>
            {type === 'announcement' && <><option value="acknowledged">Acknowledged</option><option value="pending">Awaiting acknowledgement</option></>}
          </select>
        </div>
        <div className="overflow-x-auto"><table className="w-full text-left text-sm border-collapse">
          <thead><tr className="border-b"><th className="p-3">Parent</th><th className="p-3">Children</th><th className="p-3">First Viewed (Lagos)</th>{type === 'announcement' && <th className="p-3">Acknowledged (Lagos)</th>}<th className="p-3">Status</th></tr></thead>
          <tbody>{readers.map(reader => <tr key={reader.parentId} className="border-b align-top">
            <td className="p-3 break-words"><strong>{reader.name}</strong><div>{reader.email}</div></td>
            <td className="p-3">{reader.children.join(', ') || '-'}</td><td className="p-3">{date(reader.readAt)}</td>
            {type === 'announcement' && <td className="p-3">{date(reader.acknowledgedAt)}</td>}
            <td className="p-3">{reader.acknowledgedAt ? 'Acknowledged' : reader.isRead ? 'Viewed' : 'Unseen'}{reader.dismissed && ' / Removed'}</td>
          </tr>)}</tbody>
        </table></div>
        {!readers.length && <p className="py-5">No matching parents.</p>}
      </>}
    </section>
  </div>;
}
